import React from 'react';
import { Navigate } from 'react-router-dom';
import { canViewPaymentAdmin } from '../../utils/authConfig';

const PaymentAdminRoute = ({ children }) => {
  if (!canViewPaymentAdmin()) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default PaymentAdminRoute;
